<template>
  <div class="kpi-panel-bb">
    <div class="kpi-header">
      <span class="kpi-title">VISIÓN GENERAL</span>
      <span class="kpi-subtitle">Estado del portfolio</span>
    </div>

    <div class="kpi-grid">
      <button class="kpi-card" :disabled="true">
        <div class="kpi-card-label">ÍNDICE COMPETITIVIDAD</div>
        <div class="kpi-card-value">
          <span class="kpi-num">{{ kpis.competitiveness_index || 0 }}</span><span class="kpi-unit">%</span>
        </div>
        <div class="kpi-card-hint">—</div>
      </button>

      <button class="kpi-card kpi-positive" @click="$emit('verLista', 'ganadores')">
        <div class="kpi-card-label">PRODUCTOS GANADORES</div>
        <div class="kpi-card-value">
          <span class="kpi-num">{{ formatNumber(kpis.cheapest_in_competition_count) }}</span>
        </div>
        <div class="kpi-card-hint">ver lista →</div>
      </button>

      <button class="kpi-card kpi-danger" @click="$emit('verLista', 'perdedores')">
        <div class="kpi-card-label">PRODUCTOS PERDEDORES</div>
        <div class="kpi-card-value">
          <span class="kpi-num">{{ formatNumber(kpis.losing_in_competition_count) }}</span>
        </div>
        <div class="kpi-card-hint">ver lista →</div>
      </button>

      <button class="kpi-card kpi-positive" @click="$emit('verLista', 'exclusivos')">
        <div class="kpi-card-label">PRODUCTOS EXCLUSIVOS</div>
        <div class="kpi-card-value">
          <span class="kpi-num">{{ formatNumber(kpis.exclusive_products_count) }}</span>
        </div>
        <div class="kpi-card-hint">ver lista →</div>
      </button>

      <button class="kpi-card kpi-accent" @click="$emit('verLista', 'competencia')">
        <div class="kpi-card-label">TOTAL EN COMPETENCIA</div>
        <div class="kpi-card-value">
          <span class="kpi-num">{{ formatNumber(kpis.competitive_products_count) }}</span>
        </div>
        <div class="kpi-card-hint">ver lista →</div>
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({ kpis: Object });
defineEmits(["verLista"]);

function formatNumber(n) {
  if (n === null || n === undefined) return '0';
  return Number(n).toLocaleString('es');
}
</script>

<style scoped>
.kpi-panel-bb {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 3px;
  overflow: hidden;
}

/* ==================== HEADER ==================== */
.kpi-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 10px 16px;
  background: var(--color-surface-3);
  border-bottom: 1px solid var(--color-accent-border);
}
.kpi-title {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: var(--color-accent);
}
.kpi-subtitle {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  letter-spacing: 0.05em;
}

/* ==================== GRID ==================== */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background: var(--color-border);
  gap: 1px;  /* Los bordes entre cards vienen del gap sobre bg border */
}

/* ==================== CARD ==================== */
.kpi-card {
  background: var(--color-surface);
  border: none;
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  cursor: pointer;
  transition: background 0.15s;
  font-family: inherit;
  color: inherit;
  border-left: 3px solid transparent;
}
.kpi-card:hover:not(:disabled) {
  background: var(--color-hover-bg);
  border-left-color: var(--color-accent);
}
.kpi-card:disabled {
  cursor: default;
}

/* ==================== LABEL (arriba) ==================== */
.kpi-card-label {
  font-family: var(--font-mono);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--color-text-muted);
  margin-bottom: 8px;
  line-height: 1.2;
}

/* ==================== VALUE (número grande) ==================== */
.kpi-card-value {
  display: flex;
  align-items: baseline;
  gap: 2px;
}
.kpi-num {
  font-family: var(--font-mono);
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  color: var(--color-text);
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}
.kpi-unit {
  font-family: var(--font-mono);
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-muted);
  margin-left: 2px;
}

/* Variantes semánticas del número */
.kpi-positive .kpi-num { color: var(--color-success-text); }
.kpi-danger   .kpi-num { color: var(--color-danger-text); }
.kpi-accent   .kpi-num { color: var(--color-accent); }

/* ==================== HINT (ver lista →) ==================== */
.kpi-card-hint {
  font-family: var(--font-mono);
  font-size: 10px;
  color: var(--color-text-faint);
  margin-top: 8px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.kpi-card:hover:not(:disabled) .kpi-card-hint {
  color: var(--color-accent);
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 1200px) {
  .kpi-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .kpi-grid {
    grid-template-columns: 1fr;
  }
  .kpi-num {
    font-size: 26px;
  }
}
</style>